import { useQuery } from '@apollo/client';

import GET_ADMINDASHBOAD_NEW_COURSES from '../graphql/GetAdminDashboardNewCourses.graphql';
import GET_ADMINDASHBOAD_NEWS from '../graphql/GetAdminDashboardNews.graphql';
import type {
  GetAdminDashboardNewCourses,
  GetAdminDashboardNewCoursesVariables,
} from '../graphql/types/GetAdminDashboardNewCourses';
import type {
  GetAdminDashboardNews,
  GetAdminDashboardNewsVariables,
} from '../graphql/types/GetAdminDashboardNews';
import type { INewsDialogItem } from '../types';

const useAdminDashboardUpdates = ({ skip }: { skip: boolean }) => {
  const {
    loading: loadingNews,
    error: errorNews,
    data: newsData,
  } = useQuery<GetAdminDashboardNews, GetAdminDashboardNewsVariables>(
    GET_ADMINDASHBOAD_NEWS,
    {
      variables: {
        lastDays: 7,
      },
      skip,
    },
  );

  const {
    loading: loadingCourses,
    error: errorCourses,
    data: coursesData,
  } = useQuery<
    GetAdminDashboardNewCourses,
    GetAdminDashboardNewCoursesVariables
  >(GET_ADMINDASHBOAD_NEW_COURSES, {
    variables: {
      filterBy: 'last7days',
      courseType: 'paid',
    },
    skip,
  });

  const loading = loadingNews || loadingCourses;
  const error = errorNews || errorCourses;

  const news: INewsDialogItem[] =
    newsData?.news?.edges.map(el => ({
      type: 'news',
      originalId: el?.node?.originalId || null,
      description: el?.node?.description || null,
      image: el?.node?.newsImage || null,
      promoVideoUrl: null,
      url: el?.node?.url || null,
      title: el?.node?.title || null,
    })) || [];
  const courses: INewsDialogItem[] =
    coursesData?.newCourses?.edges.map(el => ({
      type: 'course',
      originalId: el?.node?.originalId || null,
      description: el?.node?.shortDescriptionWithoutHtml || null,
      image: el?.node?.promoImage || null,
      promoVideoUrl: el?.node?.promoVideoUrl || null,
      url: el?.node?.url || null,
      title: el?.node?.title || null,
    })) || [];

  const updates = [...news, ...courses];

  return { loading, error, updates };
};

export default useAdminDashboardUpdates;
